import { useEffect, useState } from 'react';
import { useAccessToken } from '../auth/use-access-token.js';
import { readMyCredits } from '../api/family-credits.js';

/**
 * Remaining credits on a parent's Account (031; board C5, approved 27
 * October; Matthew: "Remaining credits, not lessons left"; every parent of
 * the family sees it - a second parent's account resolves to the family's).
 * Read only. With none left the line still shows, at 0.
 */
export function MyCredits() {
  const getToken = useAccessToken();
  const [credits, setCredits] = useState<{ service_name: string; remaining: number }[] | null>(null);

  useEffect(() => {
    let cancelled = false;
    readMyCredits(getToken)
      .then((found) => {
        if (!cancelled) setCredits(found);
      })
      .catch(() => {
        if (!cancelled) setCredits(null);
      });
    return () => {
      cancelled = true;
    };
  }, [getToken]);

  if (!credits) return null;
  const rows = credits.length > 0 ? credits : [{ service_name: 'Lesson credits', remaining: 0 }];

  return (
    <>
      <span className="section-label">Remaining credits</span>
      {rows.map((row) => (
        <div key={row.service_name} className="hour-row credit-balance">
          <span className="name">{row.service_name}</span>
          <span className="credit-remaining">{row.remaining}</span>
        </div>
      ))}
    </>
  );
}
